import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { CompanyScopeService } from '../services/company-scope.service';

export const companyScopeInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET' || !isEmployeeCollection(req.url)) {
    return next(req);
  }

  // The login-time self-lookup (GET /employees?email=…) resolves the current user's own
  // record. It is already narrowed to one person, and scoping it would break the header
  // and profile entirely if their record sat outside the claimed node — so leave it be.
  if (req.params.has('email') || /[?&]email=/.test(req.url)) {
    return next(req);
  }

  // A caller that scoped itself deliberately wins — never append on top of that.
  if (req.params.has('org_node') || /[?&]org_node=/.test(req.url)) {
    return next(req);
  }

  // Resolving the claim's company *names* to org node paths needs the org hierarchy, so
  // this is async — cached after the first load, see CompanyScopeService.
  return inject(CompanyScopeService).getOrgNodePaths().pipe(
    switchMap(paths => {
      if (!paths.length) return next(req);
      return next(req.clone({ params: req.params.set('org_node', paths.join(',')) }));
    })
  );
};

function isEmployeeCollection(url: string): boolean {
  const path = url.split('?')[0].replace(/\/+$/, '');
  // field-changes/pending returns a cross-employee batch list, so it is a collection in the
  // same sense as /employees itself and needs the same scoping — the approvals screen and the
  // dashboard KPI both read it.
  if (!/\/employees(\/(search|draft|field-changes\/pending))?$/.test(path)) return false;
  return !/\/[^/]+\/\d+\/employees(\/(search|draft))?$/.test(path)
      && !path.includes('/enrolment-batches/');
}
